import { combineReducers } from 'redux';

import authReducer from './authReducer';
import equipmentReducer from './equipmentReducer';
import snackBarReducer from './snackBarReducer';
import statusReducer from './statusReducer';
import catalogReducer from './catalogReducer';
import parameterReducer from './parameterReducer';
import contractReducer from './contractReducer';
import insuranceReducer from './insuranceRedurcer';
import transactionReducer from './transactionReducer';
import globalInvoiceReducer from './globalInvoiceReducer';
import globalPaymentReducer from './globalPaymentReducer';
import billingReducer from './billingReducer';
import interestBalanceReducer from './interestBalanceReducer';
import contributionReducer from './contributionsReducer';
import capitalBalanceReducer from './capitalBalanceReducer';
import contractActionsReducer from './contractActionsReducer';
import rentResumeReducer from './rentResumeReducer';
import amortizationBalanceReducer from './amortizationBalanceReducer';
import incomeResumenReducer from './incomeResumeReducer';
import distributorReducer from './distributorReducer';
import UserProfileReducer from './userProfileReducer';
import kamReducer from './kamReducer';
import quoteReducer from './quoteReducer';
import clientReducer from './clientReducer';
import notificationReducer from './notificationReducer';
import businessReducer from './businessReducer';
import administratorsReducer from './administratorsReducer';
import investorReducer from './investorReducer';
import agentsReducer from './agentReducer';
import counselorReducer from './counselorReducer';
import investmentReducer from './investmentReducer';
import cfdisReducer from './cfdiReducer';
import breadcrumbReducer from './bredcrumbsReducer';
import backgroundValidationReducer from './backgroundValidationReducer';
import bureauFormReducer from './bureauFormReducer';
import avalBuroFormReducer from './avalBuroFormReducer';
import upfrontRentsReducer from './upfrontRentsReducer';
import paymentReducer from './paymentReducer';
import santanderClabeReducer from './santanderClabeReducer';
import santanderDomiciledCollectionReducer from './santanderDomiciledCollectionReducer';
import bureauReportReducer from './bureauReportReducer';
import bureauReportDetailReducer from './bureauReportDetailReducer';
import accountingReducer from './accountingReducer';
import cardMovementsReducer from './cardMovementsReducer';
import cardFormReducer from './cardFormReducer';

export default () =>
  combineReducers({
    status: statusReducer,
    auth: authReducer,
    equipments: equipmentReducer,
    catalog: catalogReducer,
    parameter: parameterReducer,
    clients: clientReducer,
    contracts: contractReducer,
    contributions: contributionReducer,
    insurances: insuranceReducer,
    transactions: transactionReducer,
    globalInvoices: globalInvoiceReducer,
    globalPayments: globalPaymentReducer,
    billings: billingReducer,
    interestBalance: interestBalanceReducer,
    capitalBalance: capitalBalanceReducer,
    contractActions: contractActionsReducer,
    rentResume: rentResumeReducer,
    amortizationBalance: amortizationBalanceReducer,
    incomeResume: incomeResumenReducer,
    distributor: distributorReducer,
    userProfile: UserProfileReducer,
    snackbar: snackBarReducer,
    kams: kamReducer,
    quotes: quoteReducer,
    payments: paymentReducer,
    notifications: notificationReducer,
    business: businessReducer,
    administrators: administratorsReducer,
    investors: investorReducer,
    agents: agentsReducer,
    counselors: counselorReducer,
    investments: investmentReducer,
    cfdis: cfdisReducer,
    breadcrumb: breadcrumbReducer,
    backgroundValidations: backgroundValidationReducer,
    bureauForm: bureauFormReducer,
    avalBuroForm: avalBuroFormReducer,
    upfrontRents: upfrontRentsReducer,
    santanderClabe: santanderClabeReducer,
    santanderDomiciledCollection: santanderDomiciledCollectionReducer,
    bureauReports: bureauReportReducer,
    bureauReportDetail: bureauReportDetailReducer,
    accounting: accountingReducer,
    cardMovements: cardMovementsReducer,
    cardForm: cardFormReducer
  });
